export default function SectionHeader({ kicker, title, lead, align = 'left', className = '' }) {
  const alignClass = align === 'center' ? 'text-center mx-auto' : 'text-left';
  const maxWidth = align === 'center' ? 'max-w-3xl' : 'max-w-2xl';
  return (
    <div className={`${alignClass} ${maxWidth} ${className}`}>
      {kicker && <p className="mono-label text-vl-violet mb-4">{kicker}</p>}
      <h2 className="font-serif-display text-3xl sm:text-4xl lg:text-[44px] text-vl-ink leading-[1.08]">
        {title}
      </h2>
      {lead && <p className="mt-5 text-base sm:text-lg text-vl-ink/70 leading-relaxed">{lead}</p>}
    </div>
  );
}
